export enum ButtonSizeType {
  X_SMALL,
  SMALL,
  MEDIUM,
  LARGE,
  X_LARGE
}
